import React, { useState } from 'react';
import { Form, Button, Tabs, Tab, Alert, InputGroup } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLES = [
  { key: 'admin', label: 'Admin', icon: 'bi-shield-lock' },
  { key: 'sales', label: 'Sales', icon: 'bi-person-badge' },
  { key: 'builder', label: 'Builder', icon: 'bi-buildings' },
  { key: 'support', label: 'Support', icon: 'bi-headset' },
];

const Login = () => {
  const { login, loading } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [role, setRole] = useState('admin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [err, setErr] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      await login(email, password, role);
      const target = loc.state && loc.state.from ? loc.state.from.pathname : '/dashboard';
      nav(target, { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="text-center mb-3">
          <i className="bi bi-buildings-fill text-primary" style={{ fontSize: '2rem' }}></i>
          <h4 className="mb-0 mt-2">Aaarya Real Estate CRM</h4>
          <small className="text-muted">Sign in to your account</small>
        </div>

        <Tabs activeKey={role} onSelect={(k) => setRole(k)} className="mb-3" justify>
          {ROLES.map((r) => (
            <Tab
              key={r.key}
              eventKey={r.key}
              title={
                <span>
                  <i className={`bi ${r.icon} me-1`}></i> {r.label}
                </span>
              }
            />
          ))}
        </Tabs>

        {err && <Alert variant="danger" className="py-2">{err}</Alert>}

        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={`${role}@aaarya.com`}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPwd ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••"
                required
              />
              <Button variant="outline-secondary" onClick={() => setShowPwd(!showPwd)}>
                <i className={`bi bi-eye${showPwd ? '-slash' : ''}`}></i>
              </Button>
            </InputGroup>
          </Form.Group>
          <Button type="submit" variant="primary" className="w-100" disabled={loading}>
            {loading ? 'Signing in…' : `Sign in as ${role.toUpperCase()}`}
          </Button>
        </Form>

        <div className="text-center mt-3 small text-muted">
          Demo: <code>{role}@aaarya.com</code> / <code>{role}@123</code>
        </div>
      </div>
    </div>
  );
};

export default Login;
